import { makeStyles } from 'tss-react/mui';

export default makeStyles()({
    container: {
        display: 'flex',
        alignItems: 'center',
        minHeight: 84,
        paddingRight: 20,
        boxShadow: '0px 10px 40px rgba(200, 212, 220, 0.35)',
        background: '#fff',
        position: 'relative',
        zIndex: 99,
        '@media (max-width: 960px)': {
            paddingRight: 20,
            minHeight: 66
        }
    },
    logoBox: {
        width: 260,
        minWidth: 260,
        display: 'flex',
        justifyContent: 'center',
        '@media (max-width: 960px)': {
            width: 85,
            minWidth: 85
        }
    },
    searchBarRoot: {
        marginRight: 24,
        '@media (max-width: 480px)': {
            display: 'none'
        }
    },
    buttons: {
        marginLeft: 'auto',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'flex-end'
    },
    menuButton: {
        marginLeft: 12,
        '@media (min-width: 480px)': {
            display: 'none'
        }
    }
});
